import React from "react";
import { useState, useEffect } from "react";

const GradientHeader = ({ logoSrc, justifyContent, showGradient, headerColor }) => {
  const [imgError, setImgError] = useState(false);
  const [logoStyle, setLogoStyle] = useState({
    height: "auto",
    maxHeight: "40px",
    maxWidth: "80px",
    width: "auto",
    objectFit: "contain",
    marginRight: "0px",
  });

  const checkLogoVisibility = (src, error) => {
    const defaultSwageazyLogo =
      "http://content.swageazy.com/website/logo-white-2_1767096866117.png";
    return (
      src &&
      src !== "" &&
      src !== "null" &&
      src !== defaultSwageazyLogo &&
      !error
    );
  };

  const handleImageLoad = (e) => {
    const img = e.target;
    const aspectRatio = img.naturalWidth / img.naturalHeight;
    const viewportWidth = window.innerWidth;

    // Base sizes that will be adjusted by screen width
    let baseMaxWidth = 80;
    let baseMaxHeight = 40;
    let margin = "0px"; // Default margin

    // Adjust sizes according to viewport width
    if (viewportWidth >= 1920) {
      // Extra large screens (4K, large monitors)
      baseMaxWidth = 94;
      baseMaxHeight = 46;
    } else if (viewportWidth >= 1440) {
      // Large screens (laptops, desktops)
      baseMaxWidth = 86;
      baseMaxHeight = 43;
    } else if (viewportWidth >= 1024) {
      // Medium screens (tablets landscape)
      baseMaxWidth = 80;
      baseMaxHeight = 40;
    } else if (viewportWidth >= 768) {
      // Small tablets
      baseMaxWidth = 66;
      baseMaxHeight = 34;
    } else if (viewportWidth >= 576) {
      // Large phones
      baseMaxWidth = 66;
      baseMaxHeight = 34;
    } else {
      // Small phones
      baseMaxWidth = 54;
      baseMaxHeight = 26;
    }

    // Then adjust for aspect ratio with more conservative scaling
    if (aspectRatio > 2.5) {
      // Very wide logos (like banners)
      setLogoStyle((prev) => ({
        ...prev,
        maxWidth: `${Math.min(baseMaxWidth * 1.5, 134)}px`,
        maxHeight: `${Math.min(baseMaxHeight * 0.9, 40)}px`,
        margin: margin,
      }));
    } else if (aspectRatio > 1.5) {
      // Wide logos
      setLogoStyle((prev) => ({
        ...prev,
        maxWidth: `${Math.min(baseMaxWidth * 1.1, 106)}px`,
        maxHeight: `${Math.min(baseMaxHeight * 0.9, 40)}px`,
        margin: margin,
      }));
    } else if (aspectRatio < 0.7) {
      // Very tall logos
      setLogoStyle((prev) => ({
        ...prev,
        maxWidth: `${Math.min(baseMaxWidth * 0.6, 54)}px`,
        maxHeight: `${Math.min(baseMaxHeight * 1.2, 54)}px`,
        margin: margin,
      }));
    } else if (aspectRatio < 1) {
      // Tall logos
      setLogoStyle((prev) => ({
        ...prev,
        maxWidth: `${Math.min(baseMaxWidth * 0.8, 66)}px`,
        maxHeight: `${Math.min(baseMaxHeight * 1.1, 46)}px`,
        margin: margin,
      }));
    } else {
      // Regular aspect ratio (close to square)
      setLogoStyle((prev) => ({
        ...prev,
        maxWidth: `${baseMaxWidth}px`,
        maxHeight: `${baseMaxHeight}px`,
        margin: margin,
      }));
    }
  };

  // Add resize listener
  useEffect(() => {
    const handleResize = () => {
      // Trigger handleImageLoad again on resize
      const img = document.querySelector(".theme-logo-image");
      if (img) {
        handleImageLoad({ target: img });
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!checkLogoVisibility(logoSrc, imgError)) return null;

  const defaultColor = "#1E1665";
  const resolvedHeaderColor = headerColor || defaultColor;

  return (
    <div
      style={{
        width: "100%",
        paddingTop: "12px",
        paddingBottom: "12px",
        background: showGradient
        ? `linear-gradient(
            to bottom,
            ${resolvedHeaderColor} 0%,
            rgba(58,94,255,0) 100%
          )`
        : "transparent",
        display: "flex",
        justifyContent: justifyContent || "flex-start",
        alignItems: "center",
        minHeight: "40px",
        paddingRight: justifyContent === "flex-end" ? "28px" : "0px",
        paddingLeft: justifyContent === "flex-start" ? "28px" : "0px",
      }}
    >
      <img
        className="img-fluid theme-logo-image"
        src={logoSrc}
        alt="Logo"
        style={logoStyle}
        onError={() => setImgError(true)}
        onLoad={handleImageLoad}
      />
    </div>
  );
};

export default GradientHeader;
